import React from 'react';

import get from 'lodash.get';
import { randomUuidKey } from 'Helpers/randomUuidKey';
import { Ad } from '@autovia-uk/polaris-components/components/atoms/Ad';
import { Heading } from '@autovia-uk/polaris-components/components/molecules/Heading';

import { getArticleGroup } from '@autovia-uk/polaris-components/sharedPartials/getArticleGroup';
import { getBreadcrumbs } from '@autovia-uk/polaris-components/sharedPartials/getBreadcrumbs';
import { getGoTo } from 'SharedPartialsLocal/getGoTo';
import { getTags } from '@autovia-uk/polaris-components/sharedPartials/getTags';
import { getSocial } from 'SharedPartialsLocal/getSocial';
import { getReviewMultipageNavigation } from '@autovia-uk/polaris-components/sharedPartials/getReviewMultipageNavigation';

import { getInlineAdConfig } from '@autovia-uk/polaris-components/sharedHelpers/getInlineAdConfig';
import { getRelatedContent } from 'SharedPartialsLocal/getRelatedContent';
import { getSimilarProductContent } from '@autovia-uk/polaris-components/sharedHelpers/getSimilarProductContent';
import { getMostPopularArticleGroup } from '@autovia-uk/polaris-components/sharedHelpers/getMostPopularArticleGroup';
import { getReviewTitleFromSpecPage } from 'Helpers/getReviewTitleFromSpecPage';
import { getReviewURLFromSpecPage } from 'Helpers/getReviewURLFromSpecPage';

import SpecList from 'Templates/spec-list/SpecList';
import { specListShape } from './props-shape';
import 'Styles/components/templates/_Specs.scss';

const SpecListTemplate = (props) => {
  const {
    config: {
      siteUrl,
    },
    layoutData: {
      page: {
        tags,
        title,
        url,
        subtitle,
        kicker,
        isSponsored,
        associatedContent,
        breadcrumbs,
      },
    },
  } = props;

  const trims = get(props, 'layoutData.page.vehicleSpecList.trims', null);
  const multipage = getRelatedContent({ related: associatedContent, key: 'relatedPages' });

  return (
    <>
      <div className="polaris__body">
        <main className="polaris__main" id="main">
          <div className="polaris__core-content polaris__content">
            { getBreadcrumbs({ breadcrumbs, isSponsored, kicker }) }
            <Heading size={1} extraClassNames={{ '-title': true }}>
              { title }
            </Heading>
            <Heading size={2} extraClassNames={{ '-subtitle': true }}>
              { subtitle }
            </Heading>
            {getGoTo({
              url: getReviewURLFromSpecPage(url, 'prices-specs'),
              title: getReviewTitleFromSpecPage(title, 'prices-specs'),
              icon: 'polaris__ico-bolt',
            })}
          </div>
          <div className="polaris__core-content polaris__content">
            {getReviewMultipageNavigation({
              multipage,
              currentUrl: url,
              nextIcon: 'polaris__ico-right-chevron',
              prevIcon: 'polaris__ico-left-chevron',
            })}
          </div>
          {trims && (
            <>
              <main className="polaris__core-content polaris__content polaris__simple-grid -body-copy">
                <div className="polaris__simple-grid--full">
                  <SpecList vehicleSpecList={trims} />
                </div>
                <div className="polaris__simple-grid--full">
                  <Ad
                    isSpaceReserved
                    key={randomUuidKey('ad-')}
                    {...getInlineAdConfig(1).props}
                  />
                </div>
                <div className="polaris__core-content polaris__simple-grid--full">
                  <div className="-tags-social">
                    {getTags({
                      tags,
                      checkTagsCondition: false,
                      extraClassNames: { '-article': true },
                    })}
                    {getSocial({
                      siteUrl,
                      url,
                      title,
                      extraClassNames: { '-article': true },
                    })}
                  </div>
                </div>
              </main>
            </>
          )}
          <div className="polaris__core-content polaris__content">
            {getArticleGroup({
              title: 'Have You Considered?',
              content: getSimilarProductContent({ related: associatedContent, key: 'recommended' }),
              articlesPerRow: 4,
              articleCardProps: { datePosition: 'meta', showRating: true, excerpt: null },
              extraClassNames: { 'polaris__review--consider': true },
            })}
            {getMostPopularArticleGroup({
              articleCardProps: {
                datePosition: 'bottom',
                isHeading: false,
                showRating: true,
              },
              associatedContent,
              nativeAd: 'native_article',
            })}
          </div>
        </main>
      </div>
    </>
  );
};

SpecListTemplate.propTypes = {
  ...specListShape,
};

export { SpecListTemplate };
